export class ForceDisconnectionNotification {
	public static fromJson(other: any): ForceDisconnectionNotification {
		const instance = new ForceDisconnectionNotification();
		return instance;
	}
}
